exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app{font-family:'Microsoft YaHei', Tahoma, Arial, sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-size:.14rem;height:100%;width:100%\n}\nhtml{background:#F2F2F2\n}\n", ""]);

// exports
